const theme = {
  space: [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80]
}

export default theme
